// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"04bdcb44","567":"b05b2dd5","708":"34b0dfd5"}[chunkId] + ".chunk.css";
};